import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, API } from "@/App";
import { toast } from "sonner";
import axios from "axios";

const AuthCallback = () => {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { loginWithGoogle, setUser } = useAuth();

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (sessionIdMatch) {
        const sessionId = sessionIdMatch[1];
        
        // Get role from localStorage (set during registration) or default to client
        const selectedRole = localStorage.getItem("google_signup_role") || "client";
        localStorage.removeItem("google_signup_role"); // Clean up
        
        try {
          // Pass role to the callback
          const response = await axios.post(
            `${API}/auth/google/callback?session_id=${sessionId}&role=${selectedRole}`
          );
          
          const { access_token, user } = response.data;
          localStorage.setItem("token", access_token);
          
          toast.success(`Welcome, ${user.name}!`);
          navigate(user.role === "stylist" ? "/stylist" : "/dashboard", { 
            replace: true 
          });
          
          // Force a page reload to update auth context
          window.location.href = user.role === "stylist" ? "/stylist" : "/dashboard";
        } catch (error) {
          console.error("Auth error:", error);
          toast.error("Authentication failed");
          navigate("/login", { replace: true });
        }
      } else {
        navigate("/login", { replace: true });
      }
    };

    processAuth();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-stone-950">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-amber-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-stone-400">Completing sign in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
